import { Permission } from 'common/types';
import { useSelector } from 'react-redux';
import * as UserSelectors from 'selectors/UserSelectors';

export const usePermissions = () => {
	const userPermissions = useSelector(UserSelectors.userPermissions);

	const hasPermission = (permission: Permission) => {
		return !!userPermissions.includes(permission);
	};
	return {
		hasPermission,
	};
};
